import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  readPosts: {
    byId: {},
  },
  error: '',
  headerImage: {},
  actionsloading: false,
});

export function connectionReducer(state = initialState, action) {
  // console.log('in connection reduecer....', action)
  switch (action.type) {
    case actionTypes.FETCH_COLLECTION:
    case actionTypes.FETCH_ONE:
    case actionTypes.FETCH_HEADER_IMAGE:
    case actionTypes.SAVE_READ_POST:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.FETCH_ONE_SUCCESS:
    case actionTypes.FETCH_COLLECTION_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };

    case actionTypes.FETCH_HEADER_IMAGE_SUCCESS:
      return {
        ...state,
        headerImage: action.payload,
        actionsloading: false,
      };
    case actionTypes.GET_READ_POSTS_SUCCESS:
      return {
        ...state,
        readPosts: {
          ...state.readPosts,
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.SAVE_READ_POST_SUCCESS:
      return {
        ...state,
        readPosts: {
          ...state.readPosts,
          byId: {
            ...state.readPosts.byId,
            [action.payload.posts_postUid]: action.payload,
          },
        },
        actionsloading: false,
      };
    default:
      return state;
  }
}
